import { useState } from "react";

const NZElectricSpec = () => {
  const [activeTab, setActiveTab] = useState("DIMENSIONS");
  const specifications = {
    "DIMENSIONS": [
      { label: "Overall Length", value: "3580mm" },
      { label: "Overall Width", value: "1550mm" },
      { label: "Overall Height", value: "2020mm" },
      { label: "Wheelbase", value: "2480mm" },
      { label: "Turning circle", value: "8600mm" },
      { label: "Ground Clearance", value: "310mm" },
      { label: "Rear cargo deck (Internal dimensions)  (L x W x H)", value: "1600mm x 1400mm x 300mm" },
    ],
    "MOTOR: 15kW (Rear)": [
      { label: "Motor Type", value: "AC-PM (Permanent magnet)" },
      { label: "Rate Voltage", value: "75VAC" },
      { label: "Rate Power", value: "15kW" },
      { label: "Peak Power", value: "30kW" },
      { label: "Rated Speed", value: "4000 rpm" },
      { label: "Max. Speed", value: "5500 rpm" },
      { label: "Number of Pole-Pairs", value: "3" },
      { label: "Rated Torque", value: "35.8N.M" },
      { label: "Max. Torque", value: "130N.M" },
      { label: "Regenerative Braking", value: "Yes" },
      { label: "Brake System", value: "Hydraulic disk with booster assist" },
      { label: "Cooling", value: "Water, with radiator and thermo fan" },
      { label: "Waterproof rating", value: "IP67" },
      { label: "Wiring Insulation Grade", value: "H" },
      { label: "Rated Current", value: "150A" },
      { label: "Peak Current", value: "400A" },
      { label: "Weight", value: "42Kg" },
    ],
    "PRIMARY BATTERY": [
      { label: "Battery type", value: "Lithium Iron Phosphate" },
      { label: "Battery voltage (V)", value: "115" },
      { label: "Capacitance (Ah)", value: "230" },
      { label: "Total watt hour kWh  ", value: "26.5" },
      { label: "Cell Specification", value: "36 cells, 230AH, 3.2V" },
      { label: "Operating Temperature", value: "0°C to 55°C" },
      { label: "Maximum Charging Current", value: "15A or 28A" },
      { label: "Weight", value: "235kg" },  
      { label: "Maximum Range", value: "120-160kms" },
    ],
    "CAPACITIES": [
      { label: "Max. Load (Rear cargo tray)", value: "550kg" },
      { label: "Max. Load (Front cargo tray)", value: "150kg" }, 
      { label: "Transfer box Oil", value: "0.80L" },
      { label: "Front Differential Oil", value: "0.45L" },
      { label: "Rear Differential Oil", value: "0.85L" },
      { label: "Coolant", value: "3.0L" },
    ],
    "SUSPENSION & BRAKES": [
      { label: "Front Suspension", value: "Independent Single A-Arm with MacPherson Strut" },
      { label: "Rear Suspension", value: "Independent Dual A-Arm with double coil springs" },
      { label: "Tyres (Front & Rear)", value: "26×11-12" },
      { label: "Tyre Pressure (Front & Rear)", value: "15-30 psi" },
      { label: "Brakes", value: "Hydraulic disc, with booster assist" },
    ],
    "STRUCTURE": [
      { label: "Chassis", value: "All steel ladder design welded box section" },
      { label: "Anti Corrosion Treatment", value: "Electrophoresis – chassis & all steel panels" },
      { label: "Net Weight", value: "1280kg" },
    ],
  };
  return (
    <div className="pt-[64px] pb-[48px]">
      <div className="custom-container px-[24px] md:px-[32px] lg:px-[48px] text-start mx-auto">
        <div className="max-w-[1400px] mx-auto">
          <h2 className="kuunari-bold text-[24px] md:text-[30px] lg:text-[40px] leading-tight text-center">
            Specifications Electric Tuatara 1500E
          </h2>
          <div className="w-full mx-auto border border-gray-300 bg-gray-50 mt-[24px] rounded-lg shadow-lg">
            <div className="flex flex-wrap  w-full border-b border-gray-300 bg-gray-200 p-2">
              {Object.keys(specifications).map((tab) => (
                <button
                  key={tab}
                  className={`flex items-center justify-center min-w-[100px] px-4 py-2 text-gray-700 cursor-pointer transition-all text-sm sm:text-base md:whitespace-nowrap ${
                    activeTab === tab
                      ? "bg-white border-b-4 border-blue-500 text-blue-600"
                      : "hover:bg-gray-300"
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="p-[12px] sm:p-[16px] md:p-[24px]">
              {specifications[activeTab].map((item, index) => (
                <div
                  key={index}
                  className="grid grid-cols-12 items-center py-[8px] sm:py-[12px] border-b border-gray-200 last:border-none"
                >
                  <div className="col-span-5 sm:col-span-3 font-semibold text-gray-900 text-[12px] sm:text-[14px] md:text-[16px] text-left">
                    {item.label}
                  </div>
                  <div className="col-span-2 sm:col-span-6 flex justify-center">
                    <div className="w-full border-t border-gray-400 mx-[8px] sm:mx-[16px]"></div>
                  </div>
                  <div className="col-span-5 sm:col-span-3 text-gray-800 text-[12px] sm:text-[14px] md:text-[16px] text-right">
                    {item.value}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};
export default NZElectricSpec;
